<mat-dialog-content class="mat-typography">
  @for (fmSystemList of fmSystemLists; track fmSystemList) {
    <p (click)="updateFmSystemList(fmSystemList)">{{fmSystemList.name}}</p>
  }
</mat-dialog-content>
